// extracted by mini-css-extract-plugin
export var header = "_gc-0";